import script from "./ds-modal-video-gdpr-overlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./ds-modal-video-gdpr-overlay.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__